import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ── Suppress browser extension errors from React's dev error overlay ──
// MetaMask and other wallet extensions inject scripts that occasionally
// throw "Failed to connect" errors unrelated to the game. We filter
// these out so the red error overlay never appears for extension noise.
function isBrowserExtensionError(event) {
  const src = event.filename || event.source || '';
  const msg = event.message || (event.reason && event.reason.message) || '';
  return (
    src.includes('chrome-extension://') ||
    src.includes('moz-extension://') ||
    msg.includes('MetaMask') ||
    msg.includes('ethereum') ||
    msg.includes('web3')
  );
}

window.addEventListener('error', (event) => {
  if (isBrowserExtensionError(event)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true /* capture phase — fires before React's handler */);

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason || {};
  const stack  = (reason.stack || reason.message || '').toString();
  if (
    stack.includes('chrome-extension://') ||
    stack.includes('moz-extension://') ||
    stack.includes('MetaMask') ||
    stack.includes('ethereum')
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);